import { Caption } from 'modules/design-system';
import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${(props) => props.theme.spacing.l};
`;

export const LinkWrapper = styled(Caption)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Footer = styled.div`
  align-items: center;
  margin-top: 24px;
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
  color: ${({ theme }) => theme.colors.text.default};
  font-size: 14px;
  line-height: 21px;
  padding-top: 16px;
  text-align: center;
`;

export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.colors.text.negative};
`;

export const Subtitle = styled(Caption)`
  margin: 0 0 ${({ theme }) => theme.spacing.m};
`;
